import { z } from "zod";
export var REQUIRED_MESSAGE = "Campo obrigatório";
export var RequiredStringSchema = z
    .string({ message: REQUIRED_MESSAGE })
    .trim()
    .min(1, REQUIRED_MESSAGE);
export var OptionalStringSchema = z.string().trim().optional();
export var RequiredEmailSchema = z
    .string({ message: REQUIRED_MESSAGE })
    .trim()
    .min(1, REQUIRED_MESSAGE)
    .email("Digite um e-mail válido");
export var RequiredPhoneSchema = z
    .string({ message: REQUIRED_MESSAGE })
    .trim()
    .nonempty(REQUIRED_MESSAGE)
    .min(15, "Número de telefone inválido");
// Maximum file size (5MB)
var MAX_FILE_SIZE = 5 * 1024 * 1024;
var ACCEPTED_IMAGE_FILE_TYPES = ["image/jpg", "image/png"];
var ACCEPTED_DOCUMENT_FILE_TYPES = ["application/pdf"];
var ACCEPTED_FILE_TYPES = [
    "image/jpeg",
    "image/jpg",
    "image/png",
    "application/pdf",
];
export var FileSchema = z
    .instanceof(FileList)
    .refine(function (files) { return (files === null || files === void 0 ? void 0 : files.length) > 0; }, {
    message: REQUIRED_MESSAGE,
})
    .refine(function (files) { var _a; return ((_a = files === null || files === void 0 ? void 0 : files[0]) === null || _a === void 0 ? void 0 : _a.size) <= MAX_FILE_SIZE; }, {
    message: "O arquivo deve ter no máximo 5MB",
})
    .refine(function (files) { var _a; return ACCEPTED_FILE_TYPES.includes((_a = files === null || files === void 0 ? void 0 : files[0]) === null || _a === void 0 ? void 0 : _a.type); }, {
    message: "Tipo de arquivo não suportado. Use: JPEG, PNG, PDF, DOC ou DOCX",
});
export var ImageFileSchema = z
    .instanceof(FileList)
    .refine(function (files) { return (files === null || files === void 0 ? void 0 : files.length) > 0; }, {
    message: REQUIRED_MESSAGE,
})
    .refine(function (files) { var _a; return ((_a = files === null || files === void 0 ? void 0 : files[0]) === null || _a === void 0 ? void 0 : _a.size) <= MAX_FILE_SIZE; }, {
    message: "O arquivo deve ter no máximo 5MB",
})
    .refine(function (files) { var _a; return ACCEPTED_IMAGE_FILE_TYPES.includes((_a = files === null || files === void 0 ? void 0 : files[0]) === null || _a === void 0 ? void 0 : _a.type); }, {
    message: "Tipo de arquivo não suportado. Use: JPG ou PNG",
});
export var ImageOptionalFileSchema = z
    .instanceof(FileList)
    .optional()
    .refine(function (files) { var _a; return !files || files.length === 0 || ((_a = files[0]) === null || _a === void 0 ? void 0 : _a.size) <= MAX_FILE_SIZE; }, {
    message: "O arquivo deve ter no máximo 5MB",
})
    .refine(function (files) {
    return !files ||
        files.length === 0 ||
        (files[0] && ACCEPTED_IMAGE_FILE_TYPES.includes(files[0].type));
}, {
    message: "Tipo de arquivo não suportado. Use: JPG ou PNG",
});
export var DocumentFileSchema = z
    .instanceof(FileList)
    .refine(function (files) { return (files === null || files === void 0 ? void 0 : files.length) > 0; }, {
    message: REQUIRED_MESSAGE,
})
    .refine(function (files) { var _a; return ((_a = files === null || files === void 0 ? void 0 : files[0]) === null || _a === void 0 ? void 0 : _a.size) <= MAX_FILE_SIZE; }, {
    message: "O arquivo deve ter no máximo 5MB",
})
    .refine(function (files) { var _a; return ACCEPTED_DOCUMENT_FILE_TYPES.includes((_a = files === null || files === void 0 ? void 0 : files[0]) === null || _a === void 0 ? void 0 : _a.type); }, {
    message: "Tipo de arquivo não suportado. Use: PDF",
});
